<template>
  <div>
    <NavbarSimakad />
    <main class="">
      <!-- <router-view /> -->
       {{ $route.params.id }}
    </main>
  </div>
</template>

<script setup>
console.log("MainLayout component loaded");
import NavbarSimakad from '@/components/simakad/NavbarSimakad.vue'
</script>
